<template>
  <DefaultLayout>
  <div>
    <div class="d-lg-none d-xl-none mt-n6"></div><div v-if="newFile" class="d-none d-md-none d-lg-block mt-n3"></div>
    <header class="py-4 bg-gradient-info">
      <div v-if="media && managedNetworks" class="container">
        <div v-if="newFile" class="row">
          <div class="alert alert-success mt-n1">{{ $t('upload-complete-please-add-more-information-to-this-file') }}</div><br>
          <div class="alert alert-info mt-n1 mb-n2">
            {{ $t('videos-may-take-a-few-minutes-to-appear-after-uploading-thank-you-for-your-patience') }}
          </div>
        </div>
        <div v-else class="row">
          <!-- Breadcrumbs -->
          <nav aria-label="breadcrumb" style="padding-left: 0 !important;">
            <ol class=" mt-2 breadcrumb align-middle">
              <li class="breadcrumb-item">
                <a :href="network ? '/networks/' + network.slug + '/media/' + media.slug : '/media/' + media.slug" class="text-primary fw-bold">
                  {{ media.title.slice(0, 15) }}<span v-if="media.title.length > 15" class="ms-n1">...</span>
                </a>
              </li>
              <li class="breadcrumb-item">
                <a class="text-secondary fw-bold">
                  {{ $t('edit-media') }}
                </a>
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </header>

    <div class="container">
      <NetworkMediaForm :managedNetworks="this.managedNetworks" :mediaForm="mediaForm" :media="media" :busy="busy" />
      <a v-if="newFile" :href="'/networks/' + network.slug + '/media/' + media.slug" class="btn bg-primary text-white">
        {{ $t('save-and-go-to-media') }}
      </a>
    </div>
  </div>
  </DefaultLayout>
</template>
<script>
import { durationForHumans } from '@/lib/util.js';
import DefaultLayout from '@/views/layouts/default/';
import NetworkMediaForm from '@/components/forms/media/NetworkMediaForm.vue';
import moment from 'moment';

export default {
  components: {
    DefaultLayout,
    NetworkMediaForm,
  },
  props: {
    slug: {
      type: String,
      default: null,
    },
    media_slug: {
      type: String,
      default: null,
    },
    network: {
      type: Object,
      default: null,
    },
    newFile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      busy: true,
      media: null,
      managedNetworks: null,
      mediaForm: {},
      isOutdated: false,
    };
  },
  watch: {
    slug(newV) {
      if (newV != this.media.slug){
        let url = this.network ? '/networks/' + this.network.slug + '/media/' + newV + '/edit' : '/media/' + newV + '/edit';
        window.location.href = url;
      }
    },/*
    mediaForm: {
      handler(newV, oldV) {
        console.log(newV, oldV);
        this.isOutdated = true;
      },
      deep: true,
    },*/
  },
  mounted() {
    this.refresh();
    this.$bus.on('network-media-form-submit', form => this.onSubmitEvent(form));
  },
  beforeDestroy() {
    this.$bus.off('network-media-form-submit');
  },
  methods: {
    formatDate(date) {
      return moment(date).format('MM-DD-YYYY hh:mma');
    },
    durationForHumans(seconds) {
      return durationForHumans(seconds);
    },
    // check the route parameter and the store, and refresh it if needed
    refresh() {
      if (this.media == null || this.media.id != this.id) {
        // refresh it!
        this.busy = true;
        let URLslug = '';
        if (this.media_slug == null) {
          URLslug = this.slug;
        } else {
          URLslug = this.media_slug;
        }
        this.$http.get('networks/media/' + URLslug).then(resp => {
          this.media = resp.data;
          // this.media.network = this.getMediaNetwork(this.media);
          this.setupForm();

          this.$store.dispatch('loadManagedNetworks').then(networks => {
            this.managedNetworks = networks;
            this.busy = false;
          });
        });
      }
    },
    getMediaNetwork(media) {
      if (media.networks.length === 1) {
        return media.networks[0];
      } else if (this.currentNetworkID) {
        return media.networks.find(network => network.id === this.currentNetworkID);
      }
      return null;
    },
    setupForm() {
      this.mediaForm = Object.assign({}, this.mediaForm, {
        id: this.media.id,
        title: this.media.title,
        slug: this.media.slug,
        permission: this.media.permission,
        presenters: this.media.presenters ? this.media.presenters : this.media.presenter_text,
        description: this.media.description,
        type: this.media.type,
        language: this.media.language,
        tags: this.media.tags,
        publish_date: this.media.publish_date,
        networks: this.media.networks,
        attachments: this.media.attachments,
        can_download: this.media.can_download,
      });
    },
    onSubmitEvent(form) {
      form.network_id = this.media.network_id;
      this.$http.put('networks/media/' + this.media.slug, form).then(resp =>{
        this.isOutdated = false;
        this.slug = resp.data.slug;
      });
    }
  },
};
</script>
<style scoped>
dl.metadata dd,
dl.metadata dt {
  float: left;
}
dl.metadata dt {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
}
dl.metadata dd {
  font-size: 12px;
  font-weight: bold;
  margin: 0 10px;
  overflow: hidden;
  width: auto;
}
</style>